import { AsidePanelActionsButton } from '../../../../..';
import * as React from 'react';
import { IBoardImportPanelButtonProps } from './types';
import {
    BOARD_IMPORT_TITLE
} from 'app/view/react_components/aside_panel/boardDetails/details/ImportBoard/components/BoardImport/constants';
import { AsidePanelContext } from '../../../../../asidePanel/components/AsidePanel/constants';
import { EBoardSetting } from '../../../TabDetails/components/TabDetails/types';

export function BoardImportPanelButton ({
    show,
    tooltip,
    onClick
}: IBoardImportPanelButtonProps) {
    const { subTab, setSubTab } = React.useContext(AsidePanelContext);
    if (!show) {
        return null;
    }
    return (
        <AsidePanelActionsButton
            children={null}
            isOpened={subTab === EBoardSetting.IMPORT}
            title={BOARD_IMPORT_TITLE}
            tooltip={tooltip}
            onClick={() => {
                setSubTab(EBoardSetting.IMPORT);
                onClick();
            }}
        />
    );
}
